import { render, staticRenderFns } from "./qrcodeDispatch.vue?vue&type=template&id=2c8a6986&scoped=true"
import script from "./qrcodeDispatch.vue?vue&type=script&lang=js"
export * from "./qrcodeDispatch.vue?vue&type=script&lang=js"
import style0 from "./qrcodeDispatch.vue?vue&type=style&index=0&id=2c8a6986&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c8a6986",
  null
  
)

export default component.exports